export function getSessionId() {
  let sessionId = localStorage.getItem('orderart_session_id');
  if (!sessionId) {
    sessionId = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem('orderart_session_id', sessionId);
  }
  return sessionId;
}